










































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: { Button }
})
export default class Paginator extends Vue {

  themeStore = useThemeStore();

  @Prop()
  page: number;

  @Prop()
  pageCount: number;

  pageInternal = 1;

  @Watch("page")
  pagePropUpdated () {
    if (this.page <= this.pageCount && this.page >= 1) {
      this.pageInternal = this.page;
    } else {
      this.$emit("switchPage", 1);
    }
  }

  mounted () {
    this.pagePropUpdated();
  }

  switchPage (page: number) {
    if (page > this.pageCount || page < 1) {
      return;
    }
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }
          this.$emit("switchPage", page);
        });
  }

  onPageKeyDown (event) {
    if (event.which === 13) {
      this.switchPage(this.pageInternal);
    }
  }
}
